import { storyblokInit as s } from "./storyblok-js.mjs";
import { BlockTypes as g, MarkTypes as C, RichTextResolver as d, RichTextSchema as f, TextTypes as x, apiPlugin as S, loadStoryblokBridge as T, registerStoryblokBridge as F, renderRichText as h, richTextResolver as A, storyblokEditable as B, registerStoryblokBridge as R } from "./storyblok-js.mjs";
import { default as v } from "./storyblok-component.mjs";
let t = null, e = {}, r = !1, l = null;
const c = () => (t || console.error(
  "You can't use getStoryblokApi if you're not loading apiPlugin."
), t), b = (o) => (e = o, e), i = (o) => e[o] ? e[o] : (console.error(`Component ${o} doesn't exist.`), !1), k = () => r, p = () => l, m = (o = {}) => {
  const { storyblokApi: n } = s(o);
  t = n, e = o.components, r = o.enableFallbackComponent, l = o.customFallbackComponent;
};
export {
  g as BlockTypes,
  C as MarkTypes,
  d as RichTextResolver,
  f as RichTextSchema,
  v as StoryblokComponent,
  x as TextTypes,
  S as apiPlugin,
  i as getComponent,
  p as getCustomFallbackComponent,
  k as getEnableFallbackComponent,
  c as getStoryblokApi,
  T as loadStoryblokBridge,
  F as registerStoryblokBridge,
  h as renderRichText,
  A as richTextResolver,
  b as setComponents,
  B as storyblokEditable,
  m as storyblokInit,
  c as useStoryblokApi,
  R as useStoryblokBridge
};
